import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Plan from '../views/plans/plan.vue'
import Separate from '../views/products/separate.vue'
import News from '../views/news/news.vue'
import About from '../views/about/about.vue'
import NewDetail from '../views/news/newDetail.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  }, {
    path: '/plan',
    name: 'plan',
    component: Plan
  }, 
   {
    path: '/separate',
    name: 'separate',
    component: Separate
  }, {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/about',
    name: 'about',
    component: About
  }, 
  {
    path: '/newDetail',
    name: 'newDetail',
    component: NewDetail
  },

]




const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 }
  }
};

const router = new VueRouter({
  routes,
  scrollBehavior
})

export default router
